import { render, staticRenderFns } from "./Cliente.vue?vue&type=template&id=db126376&scoped=true"
import script from "./Cliente.vue?vue&type=script&lang=js"
export * from "./Cliente.vue?vue&type=script&lang=js"
import style0 from "./Cliente.vue?vue&type=style&index=0&id=db126376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db126376",
  null
  
)

export default component.exports